import { UseHeader } from './Header.types'

export const useHeader: UseHeader = ({
  opportunityDetails,
  isLoading,
  handleEvaluateConclude,
  handleHighlight,
  isActiveBase,
  opportunityType,
  isMobile,
  pageTitle,
  handleCloseEvaluate,
  evaluateIsOpen,
  evaluationSuccessSheetRef,
  closeEvaluationSuccessSheet,
  handleFinishEvaluate,
  concludeIsLoading,
  highlightIsLoading,
  handleOpenDeleteOpportunityModal,
  handleCloseDeleteOpportunityModal,
  deleteOpportunityModalIsOpen,
  handleSubmitOpportunityDeletion,
  requestDeletionIsLoading,
  isDeletionRequested,
  deletionSuccessModalIsOpen,
  handleCloseDeletionSuccessModal
}) => {
  return {
    opportunityDetails,
    isLoading,
    handleEvaluateConclude,
    handleHighlight,
    isActiveBase,
    opportunityType,
    isMobile,
    pageTitle,
    handleCloseEvaluate,
    evaluateIsOpen,
    evaluationSuccessSheetRef,
    closeEvaluationSuccessSheet,
    handleFinishEvaluate,
    concludeIsLoading,
    highlightIsLoading,
    handleOpenDeleteOpportunityModal,
    handleCloseDeleteOpportunityModal,
    deleteOpportunityModalIsOpen,
    handleSubmitOpportunityDeletion,
    requestDeletionIsLoading,
    isDeletionRequested,
    deletionSuccessModalIsOpen,
    handleCloseDeletionSuccessModal
  }
}
